import { matcher, MatchType, ActionType } from "@cdv/jazz-ui";
import { Resource } from "../utils";
import CardIndex from "./CardIndex";
import CardShow from "./CardShow";

export default matcher({ resource: Resource.TestDefinition })
  .set(MatchType.View, CardIndex, { action: ActionType.INDEX })
  .set(MatchType.View, CardShow, { action: ActionType.SHOW })
  .entries();
